<template>
  <BoardView :title="$t('title')">
    <FormValidation @submit="create">
      <FormPageBatch :pageBatch="pageBatch" />
      <Btn class="info" :isLoading="isSaving" type="submit">
        {{ $t('submit') }}
      </Btn>
    </FormValidation>
  </BoardView>
</template>

<script>
import BoardAdd from '@mixins/BoardAdd'
import FormPageBatch from '@forms/FormPageBatch'

export default {
  mixins: [
    BoardAdd('pageBatch', {
      redirectTo: 'PageBatches',
    }),
  ],
  components: { FormPageBatch },
}
</script>

<i18n>
{
  "en": {
    "title": "Add pages batch",
    "submit": "Save"
  }
}
</i18n>
